export const DRAFT_STATUS_DRAFT = 'draft'
export const DRAFT_STATUS_REJECTED = 'rejected'
export const DRAFT_STATUS_ACCEPTED = 'accepted'
